<template>
    <div style="height:600px;position:relative">
        <pdf :src="data.pdffile"></pdf>
    </div>
</template>

<script>

export default {
    props: {
        data: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return{
            
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        
    },
    created() {
   
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">

</style>
